<template>
  <div>
    <div class="admin_user_createuser">
      <el-card>
        <el-form
          label-position="right"
          label-width="80px"
          @submit.native.prevent="createAdminUser"
          ref="elForm"
        >
          <el-form-item label="账号">
            <el-input type="text" v-model="model.username"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input type="password" v-model="model.password"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="model.phone"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button style="float: right" type="primary" native-type="submit"
              >创建</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <template>
      <div class="admin_user_table">
        <el-table :data="tableData" border>
          <el-table-column
            fixed
            prop="createAt"
            label="日期"
            :formatter="formatDate"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="username" label="账号名称" width="120">
          </el-table-column>
          <el-table-column prop="phone" label="手机号码" width="120">
          </el-table-column>

          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="delAdminUser(scope.row)"
                type="text"
                size="small"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter.js";

export default {
  data() {
    return {
      model: {},
      tableData: [],
    };
  },
  methods: {
    async createAdminUser() {
      try {
        const AdminUser = await this.$http.post("/user", this.model);
        //console.log(AdminUser.data.StatusCode);

        if (AdminUser.request.status == 200) {
          await this.$message({
            type: "success",
            message: AdminUser.data.msg,
          });
        }
        await this.getAdminUser();
        this.model.username = "";
        this.model.password = "";
        this.model.phone = "";
      } catch (error) {
        console.log(error);
      }
    },
    async getAdminUser() {
      try {
        const getAdminUser = await this.$http.get("/getadminuser");
        this.tableData = getAdminUser.data;
      } catch (error) {
        console.log(error);
      }
    },
    async delAdminUser(row) {
      this.$confirm(
        "此操作将删除" + `${row.username}` + "管理员账号是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(async () => {
          await this.$http.delete("/deladminuser?_id=" + `${row._id}`);

          await this.$message({
            type: "success",
            message: "删除成功",
          });
          await this.getAdminUser();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //日期格式化插件
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
  },
  created() {
    this.getAdminUser();
  },
};
</script>

<style scoped>
.admin_user_createuser {
  width: 450px;
  margin: 0 auto;
}
.admin_user_table {
  width: 550px;
  margin: 50px auto;
}
</style>
